import { createContext } from "react";

const SuggestionContext = createContext();

export default SuggestionContext;